<template>
  <ubi-panel>
    <ubi-form-group :title="$t('posts.edit.securiteBien')">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$labels.telesurveille" prop="telesurveille">
            <el-radio-group v-model="post.telesurveille">
              <el-radio label="oui" value="oui" v-model="post.telesurveille">{{ $t("general.yes") }}</el-radio>
              <el-radio label="non" value="non" v-model="post.telesurveille">{{ $t("general.no") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$labels.videosurveillance" prop="videosurveillance">
            <el-radio-group v-model="post.videosurveillance">
              <el-radio label="oui" value="oui" v-model="post.videosurveillance">{{ $t("general.yes") }}</el-radio>
              <el-radio label="non" value="non" v-model="post.videosurveillance">{{ $t("general.no") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$labels.porte_blindee" prop="porte_blindee">
            <el-radio-group v-model="post.porte_blindee">
              <el-radio label="oui" value="oui" v-model="post.porte_blindee">{{ $t("general.yes") }}</el-radio>
              <el-radio label="non" value="non" v-model="post.porte_blindee">{{ $t("general.no") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$labels.systeme_extraction_fumee" prop="systeme_extraction_fumee">
            <el-radio-group v-model="post.systeme_extraction_fumee">
              <el-radio label="oui" value="oui" v-model="post.systeme_extraction_fumee">{{ $t("general.yes") }}</el-radio>
              <el-radio label="non" value="non" v-model="post.systeme_extraction_fumee">{{ $t("general.no") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('posts.edit.systemeIncendie')" prop="systeme_incendie">
            <el-radio-group v-model="post.systeme_incendie">
              <el-radio label="oui" value="oui" v-model="post.systeme_incendie">{{ $t("general.yes") }}</el-radio>
              <el-radio label="non" value="non" v-model="post.systeme_incendie">{{ $t("general.no") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$labels.vigik" prop="vigik">
            <el-radio-group v-model="post.vigik">
              <el-radio label="oui" value="oui" v-model="post.vigik">{{ $t("general.yes") }}</el-radio>
              <el-radio label="non" value="non" v-model="post.vigik">{{ $t("general.no") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="isCmiste">
          <el-form-item :label="$labels.videophone" prop="videophone">
            <el-radio-group v-model="post.videophone">
              <el-radio label="oui" value="oui" v-model="post.videophone">{{ $t("general.yes") }}</el-radio>
              <el-radio label="non" value="non" v-model="post.videophone">{{ $t("general.no") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </ubi-form-group>
  </ubi-panel>
</template>

<script>

import { mapGetters } from 'vuex'
import UbiPanel from '../../../../components/Panel'
import UbiFormGroup from "@/components/forms/FormGroup.vue";
export default {
  name: 'SecuriteBien',
  components: {UbiFormGroup, UbiPanel },
  props: ['post', 'ddList'],
  computed: {
    ...mapGetters(['isCmiste'])
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>

</style>
